import krrishirKotha from '../../../images/krrishirKotha.png'
import freshDale from '../../../images/freshDale.png'
import priyoRiders from '../../../images/priyoRiders.png'

const ProjectData = [
  {
    id: 'PJ2001',
    title: 'Krrishir Kotha',
    description: `
    Service Website including admin panel to add or remove services.
    Form to leave review for the clients to show on homepage.
    Option for Admin to add more services to homepage.`,
    img: krrishirKotha,
    github: "https://github.com/Ahsanul-kabir/krrishir-kotha-client",
    live: "https://krrishir-kotha.web.app/"
  },
  {
    id: 'PJ2002',
    title: 'Fresh Dale',
    description: `A full-stack agency web application that allows the client to shop for their necessary products service. A charity website with a registration form to join and register in interested field. The user can also view the registered tasks altogether and also can delete tasks if he wants by going through a private route.
    `,
    img: freshDale,
    github: "https://github.com/Ahsanul-kabir/fresh-dale-client",
    live: "https://cranky-torvalds-611a26.netlify.app/"
  },
  {
    id: 'PJ2003',
    title: 'Priyo Riders',
    description:
      `A charity website with a registration form
    to join and register in interested field.
    The user can also view vihicals and take
    any of this after select then the user have
    to select destination and the user will
    see price by going through a private route.`
    ,
    img: priyoRiders,
    github: "https://github.com/Ahsanul-kabir/priyo-riders",
    live: "https://ema-john-simple-7.web.app/"
  },
]

export default ProjectData;